@if (shouldShow()) {
    @if (item.link.external) {
        <a
            [matTooltip]="isCollapsed ? item.link.text : ''"
            matTooltipPosition="right"
            [href]="item.link.url"
            target="_blank"
            rel="noopener noreferrer"
            [ngClass]="
                isMasqueraded()
                    ? 'masquerade-bg-highlighting'
                    : 'bg-highlighting'
            "
            class="sidenav-item group flex items-center px-4 py-2 text-decoration-none"
        >
            <app-sidenav-item-link
                [item]="item"
                [isCollapsed]="isCollapsed"
            ></app-sidenav-item-link>
        </a>
    } @else {
        <mat-list-item
            [matTooltip]="isCollapsed ? item.link.text : ''"
            matTooltipPosition="right"
            [routerLink]="item.link.url"
            [ngClass]="
                isMasqueraded()
                    ? 'masquerade-bg-highlighting'
                    : 'bg-highlighting'
            "
            class="sidenav-item group"
        >
            <app-sidenav-item-link
                [item]="item"
                [isCollapsed]="isCollapsed"
            ></app-sidenav-item-link>
        </mat-list-item>
    }
}
